import React, { useRef, useState, useEffect,useMemo } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Swiper, SwiperSlide } from 'swiper/react';
import "./blogs.css";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import Carousel from 'react-bootstrap/Carousel';
import { Virtual, Navigation, Pagination, Autoplay } from 'swiper/modules';
import CloseCollapse from '../../assets/icons/close-collaps.svg';
import Logout from '../../assets/icons/logout.svg';

import { Skeleton } from 'primereact/skeleton';
import ProductImage from '../../assets/images/defult-img.svg';
import Collapse from '../../assets/icons/collapse.svg';
import { imgBaseUrl2 } from '../../utils/api';
import { Dialog } from 'primereact/dialog';

// Uncomment and use if API is integrated
import { getBlogsAndNewsBySearch, imgBaseUrl } from '../../utils/api';

export default function ProductsSlider({ type, products }) {
    const [swiperRef, setSwiperRef] = useState(null);
    // const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false); // حالت لودینگ
    const [visible, setVisible] = useState(false); // Dialog visibility state
    const [dialogContent, setDialogContent] = useState({}); // Dialog content state
    const [isScrolling, setIsScrolling] = useState(false); // فلگ برای تشخیص اسکرول
    const [sliderKey, setSliderKey] = useState(0);

    // Fetch products data from API
    // useEffect(() => {
    //     const fetchProducts = async () => {
    //         setLoading(true);
    //         try {
    //             const pay = { pageSize: 0, pageIndex: 0 };
    //             const res = await getBlogsAndNewsBySearch(pay);
    //             if (res.data.isSuccess) {
    //                 setProducts(res.data.data.items);

    //             }
    //         } catch (error) {
    //             console.error('Error fetching products:', error);
    //         } finally {
    //             setLoading(false); // توقف لودینگ
    //         }
    //     };
    //     fetchProducts();
    // }, []);
    const prevLength = useRef(products.length);

    // ✅ بهینه‌سازی شده با useMemo برای جلوگیری از محاسبه‌ی غیرضروری
    const filteredProducts = useMemo(() => {
        return type === '1'
            ? products.filter((product) => product.typeId == 1 && product.showInLandingPage && product.isActive)
            : type === '2'
                ? products.filter((product) => product.typeId == 2 && product.showInLandingPage && product.isActive)
                : products.filter((product) => product.showInLandingPage && product.isActive);
    }, [type, products]);

    // ✅ جلوگیری از حلقه‌ی بی‌نهایت هنگام تغییر مقدار sliderKey
    useEffect(() => {
        if (prevLength.current !== filteredProducts.length) {
            const timer = setTimeout(() => {
                setSliderKey(prevKey => prevKey + 1);
            }, 100); // جلوگیری از تغییرات پشت سرهم

            prevLength.current = filteredProducts.length; // ذخیره مقدار قبلی
            return () => clearTimeout(timer);
        }
    }, [filteredProducts]);

    const settings = {
        arrows: filteredProducts.length > 0, // نمایش یا عدم نمایش پیکان‌ها
        autoplaySpeed: 3000,

        responsive: [
            {
                breakpoint: 3000,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    rtl:filteredProducts && filteredProducts.length > 4,
                    autoplay:filteredProducts && filteredProducts.length > 4, // فعال‌سازی خودکار
                    draggable: filteredProducts.length > 4,
                    infinite: filteredProducts.length > 4, // حلقه‌ای شدن اسلایدر
                },
            },
            {
                breakpoint: 1500,
                settings: {
                    rtl:filteredProducts && filteredProducts.length > 4,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    autoplay:filteredProducts && filteredProducts.length > 4, // فعال‌سازی خودکار
                    draggable: filteredProducts.length > 4,
                    infinite: filteredProducts.length > 4, // حلقه‌ای شدن اسلایدر
                },
            },
            {
                breakpoint: 1100,
                settings: {
                    rtl:filteredProducts && filteredProducts.length > 3,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    autoplay:filteredProducts && filteredProducts.length > 3, // فعال‌سازی خودکار
                    draggable: filteredProducts.length > 3,
                    infinite: filteredProducts.length > 3, // حلقه‌ای شدن اسلایدر
                },
            },
            {
                breakpoint: 900,
                settings: {
                    rtl:filteredProducts && filteredProducts.length > 3,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    autoplay: filteredProducts.length > 3, // اضافه کردن autoplay در اینجا
                    autoplaySpeed: 3000,
                    draggable: filteredProducts.length > 3,
                    infinite: filteredProducts.length > 3,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    rtl:filteredProducts && filteredProducts.length > 2,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                    autoplay: filteredProducts.length > 2, // اضافه کردن autoplay در اینجا
                    autoplaySpeed: 3000,
                    draggable: filteredProducts.length > 2,
                    infinite: filteredProducts.length > 2,
                },
            },
        ],
    };


    const renderHtml = (rowData) => {
        const textContent = rowData.replace(/<[^>]+>/g, ''); // حذف تگ‌های HTML
        return (
            <div
                style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '150px',
                    marginLeft: 'auto',
                    marginRight: 'auto'

                }}
                title={textContent} // نمایش متن کامل در tooltip
            >
                {textContent}
            </div>
        );
    };


    const handleMouseDown = () => setIsScrolling(false);
    const handleMouseMove = () => setIsScrolling(true);
    const handleMouseUp = (productId) => {
        if (!isScrolling) {
            window.location.href = `/product?id=${productId}`;
        }
    };
    return (
        <>
            {loading && products.length > 0 ? (
                <div className="skeleton-wrapper blog-list">
                    <Slider {...settings} rtl={true}>
                        {[...Array(5)].map((_, index) => ( // اسکلتی برای هر آیتم ایجاد کنید
                            <div className='blog-item' key={index}>
                                <div
                                    className="blog-img">
                                    <Skeleton

                                        className="img-box img-product h-100"
                                    />
                                </div>
                                {/* <div
                       className="detail flex-col"
                     > */}

                                <div className='mx-2'>
                                    <Skeleton className="mt-4" />
                                    <Skeleton className="mt-2" />
                                </div>

                                {/* </div> */}

                            </div>
                        ))}
                    </Slider>
                </div>
            ) : (


                <Slider {...settings} adaptiveHeight={true} key={sliderKey}>
                    {filteredProducts.map((product, index) => (
                        <div className='blog-list' style={{ width: 'auto' }}>
                            <div className='blog-item'>
                                <div className='blog-img'>
                                    <img src={imgBaseUrl + '300x290/' + product.logoPath} className='img-box img-product' alt="Image 1" />
                                </div>
                                <div className='detail'>
                                    <div>
                                        <h4 className=' mt-2'>{product.summery}</h4>
                                        <h6 className='mt-2 body-blog'>{renderHtml(product.body)}</h6>
                                    </div>
                                    <div className='more-btn' onClick={() => { window.location.href = `/blog?id=${product.id}` }}>
                                        <img src={Logout} alt="" />
                                    </div>

                                </div>


                            </div>
                        </div>
                    ))}


                </Slider>
            )}

        </>
    );
};

